import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Context } from '../controls/advanced-gridview/models/context';
import { FilterInfos } from '../controls/advanced-gridview/models/filter-infos';
import { Results } from '../controls/advanced-gridview/models/results-T';
import { SortInfos } from '../controls/advanced-gridview/models/sort-infos';
import { AdvancedService } from '../controls/advanced-gridview/services/advanced-service';
import { ProcessDefinition } from '../models/process-definition';
import { CrudService } from './crud-service';
import { MemoryService } from './memory.service';

@Injectable({
    providedIn: 'root',
})
export class ProcessDefinitionService extends CrudService implements AdvancedService<ProcessDefinition> {
    constructor(
        private http: HttpClient,
        public override memoryService: MemoryService
    ) {
        super(memoryService);
    }

    List(context: Context, filters: FilterInfos[], generalFilters: FilterInfos[], sortInfos: SortInfos, pageNumber = 0, pageSize = 100): Observable<Results<ProcessDefinition>> {
        let params = new Map<string, string | number | boolean>();
        params.set('from', pageNumber);
        params.set('size', pageSize);

        const httpOptions = this.getListHttpOptions(context, filters, generalFilters, sortInfos, params);

        // Appel de la Web Api
        return this.http.get(this.baseUrl + `/api/Organizations/${this.organizationId}/views/${this.viewId}/ProcessDefinitions`, httpOptions).pipe(
            map((x) => {
                var res = Results.getCopyFrom<ProcessDefinition>(ProcessDefinition, x);

                return res;
            })
        );
    }

    Export(context: Context, filters: FilterInfos[], generalFilters: FilterInfos[], sortInfos: SortInfos): Observable<Blob> {
        const headers = this.getExportHeader(context, filters, generalFilters, sortInfos);

        // Appel de la Web Api
        return this.http
            .get(this.baseUrl + `/api/Organizations/${this.organizationId}/views/${this.viewId}/ProcessDefinitions/export`, {
                headers: headers,
                responseType: 'blob',
            })
            .pipe(
                map((res: any) => {
                    const blob = new Blob([res], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                    return blob;
                })
            );
    }

    update(processDefinitionId: number, processDefinition: ProcessDefinition): Observable<ProcessDefinition> {
        processDefinition.definition = JSON.parse(processDefinition.definitionJson);
        // Appel de la Web Api
        return this.http
            .put<ProcessDefinition>(
                this.baseUrl + `/api/Organizations/${this.organizationId}/views/${this.viewId}/ProcessDefinitions/${processDefinitionId}`,
                processDefinition,
                this.getDefaultHttpOptions()
            )
            .pipe(
                map((x) => {
                    x.definitionJson = JSON.stringify(x.definition);
                    return x;
                })
            );
    }

    delete(processDefinitionId: number): Observable<boolean> {
        // Appel de la Web Api
        return this.http
            .delete<ProcessDefinition>(
                this.baseUrl + `/api/Organizations/${this.organizationId}/views/${this.viewId}/ProcessDefinitions/${processDefinitionId}`,
                this.getDefaultHttpOptions()
            )
            .pipe(
                map((x) => {
                    return true;
                })
            );
    }

    add(processDefinition: ProcessDefinition): Observable<ProcessDefinition> {
        // Appel de la Web Api
        return this.http
            .post<ProcessDefinition>(
                this.baseUrl + `/api/Organizations/${this.organizationId}/views/${this.viewId}/ProcessDefinitions`,
                processDefinition,
                this.getDefaultHttpOptions()
            )
            .pipe(
                map((x) => {
                    x.definitionJson = JSON.stringify(x.definition);
                    return x;
                })
            );
    }

    get(processDefinitionId: number): Observable<ProcessDefinition> {
        // Appel de la Web Api
        return this.http
            .get<ProcessDefinition>(
                this.baseUrl + `/api/Organizations/${this.organizationId}/views/${this.viewId}/ProcessDefinitions/${processDefinitionId}`,
                this.getDefaultHttpOptions()
            )
            .pipe(
                map((x) => {
                    x.definitionJson = JSON.stringify(x.definition);

                    return ProcessDefinition.createFrom(x);
                })
            );
    }
}
